// 한글 자음/음절, 영어 소/대문자 중 하나로 시작하는지 검사
const isStartWithKoOrEn = (str: string) => str.match(/^[ㄱ-ㅎ|가-힣|a-z|A-Z]/);
// 중국어로 시작하는지 검사
const isStartWithZh = (str: string) => str.match(/^[\u4e00-\u9fa5]/);

/**
 * 정렬 순서
 * 한글 -> 영어 -> 숫자 -> 중국어 -> 일본어
 */
export const sortByLangOrder = (a: string, b: string): number => {
  // a - 한글/영어 x
  if (!isStartWithKoOrEn(a)) {
    // a - 한글/영어 x, b - 한글/영어 x
    if (!isStartWithKoOrEn(b)) {
      // a, b - 중국어
      if (isStartWithZh(a) && isStartWithZh(b)) {
        return a.localeCompare(b, 'zh-CN'); // 중국어는 종류가 많아서 locale 적어줘야 함
      }

      // 나머지 경우
      return a.localeCompare(b);
    }

    // a - 한글/영어 x, b - 한글/영어 o
    // 한글 또는 영어로 시작하는 단어 우선 정렬
    return 1;
  }

  // a - 한글/영어 o,  b - 한글/영어 x
  // 한글 또는 영어로 시작하는 단어 우선 정렬
  if (!isStartWithKoOrEn(b)) {
    return -1;
  }

  // a, b - 한글/영어 o
  return a.localeCompare(b);
};
